import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { COMMENT_DRAWER_MODES } from './CommentDrawer.constant'
import ButtonComponent from 'common/button/Button.component'

import 'rc-slider/assets/index.css'
import 'react-input-range/lib/css/index.css'

const DEFAULT_EDIT_TEXT = 'EDITAR'
const DEFAULT_CANCEL_TEXT = 'CANCELAR'
const DEFAULT_SAVE_TEXT = 'GUARDAR'

const CommentBoxActions = ({
  mode,
  onSave,
  onCancel,
  disableSaveBtn,
  editText,
  cancelText,
  saveText,
  handleEnabledComment
}) => {
  const [showButtons, setShowButtons] = useState(
    mode === COMMENT_DRAWER_MODES.CREATE
  )
  const handleEditClick = () => {
    setShowButtons(true)
    handleEnabledComment()
  }

  return (
    <div className="comment-box-actions">
      <div className="d-flex justify-content-end">
        {!showButtons && (
          <ButtonComponent
            label={editText}
            type="primary"
            size={'medium'}
            onClick={handleEditClick} 
          />
        )}
        {showButtons && (
          <>
            <div>
                <ButtonComponent
                    label={cancelText}
                    size={'medium'}
                    onClick={onCancel}
                    className="mr-2"
                />
            </div>
            <div>
                <ButtonComponent
                    label={saveText}
                    type="primary"
                    size={'medium'}
                    onClick={onSave} 
                    disabled={disableSaveBtn}
                />
            </div>
          </>
        )}
      </div>
    </div>
  )
}

CommentBoxActions.propTypes = {
  mode: PropTypes.string,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  disableSaveBtn: PropTypes.bool,
  editText: PropTypes.string,
  cancelText: PropTypes.string,
  saveText: PropTypes.string
}

CommentBoxActions.defaultProps = {
  mode: COMMENT_DRAWER_MODES.EDIT,
  onSave: () => {},
  onCancel: () => {},
  disableSaveBtn: false,
  editText: DEFAULT_EDIT_TEXT,
  cancelText: DEFAULT_CANCEL_TEXT,
  saveText: DEFAULT_SAVE_TEXT
}

export default CommentBoxActions
